import { Button, Form, Modal } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import { Moment } from 'moment';
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { absenceClient } from '../../../../core-module/services/absence/AbsenceClient';
import { AbsencePeriod } from '../../../../core-module/services/absence/types';
import { AbsenceFormComponent } from './AbsenceFormComponent';
import { AbsencePeriodFormValues } from './types';

interface OwnProps {
  readonly driverId: number;
  readonly visible: boolean;
  readonly onClose: () => void;
  readonly absencePeriod?: AbsencePeriod;
  readonly soonestAllowedAbsenceDate: Moment;
}

type Props = OwnProps & FormComponentProps<AbsencePeriodFormValues>;

const AbsenceFormContainer: React.FC<Props> = ({
  form,
  driverId,
  visible,
  absencePeriod,
  soonestAllowedAbsenceDate,
  onClose
}) => {
  const [saving, setSaving] = useState(false);

  const handleSave = () => {
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        setSaving(true);

        const payload = {
          reason: values.reason,
          from: values.from.toISOString(true),
          to: values.to.toISOString(true)
        };

        const promise = absencePeriod
          ? absenceClient.updateAbsence(driverId, absencePeriod.id, payload)
          : absenceClient.createAbsence(driverId, payload);

        promise
          .then(() => {
            Swal({
              title: 'Afwezigheidsperiode opgeslagen',
              html: 'De afwezigheidsperiode is succesvol opgeslagen',
              type: 'success',
              confirmButtonText: 'Ok'
            }).then(onClose);
          })
          .catch((err) => {
            Swal({
              title: 'Er is iets misgegaan',
              html: err.message,
              type: 'error',
              confirmButtonText: 'Ok'
            });
          })
          .finally(() => setSaving(false));
      }
    });
  };

  return (
    <Modal
      title={absencePeriod ? 'Afwezigheidsperiode bewerken' : 'Afwezigheidsperiode toevoegen'}
      visible={visible}
      onCancel={onClose}
      onOk={handleSave}
      footer={[
        <Button key='cancel' htmlType='button' onClick={onClose}>
          Annuleren
        </Button>,
        <Button key='save' type='primary' htmlType='button' onClick={handleSave} loading={saving}>
          Opslaan
        </Button>
      ]}
    >
      <AbsenceFormComponent
        form={form}
        absencePeriod={absencePeriod}
        soonestAllowedAbsenceDate={soonestAllowedAbsenceDate}
        saving={saving}
        onSave={handleSave}
      />
    </Modal>
  );
};

const AbsenceFormContainterWithForm = Form.create<Props>()(AbsenceFormContainer);

export { AbsenceFormContainterWithForm as AbsenceFormContainer };
